import { ApiDimension } from "@incendium/api";
import { useDimensionLabels } from "features/analytics/hooks/useDimensionLabels";
import { useCallback } from "react";

const pluralOverride = {
  [ApiDimension.DIMENSION_CITY]: "Cities",
  [ApiDimension.DIMENSION_COUNTRY]: "Countries",
  [ApiDimension.DIMENSION_DEVICE]: "Device Types (Desktop/Mobile)",
};

export const useDimensionName = () => {
  const { dimensionLabels } = useDimensionLabels();

  return useCallback(
    (dimension: ApiDimension, plural?: boolean) => {
      const found = dimensionLabels.find((ml) => ml.dimension === dimension);
      const name = found?.label && found.label !== "" ? found.label : dimension;

      return plural
        ? pluralOverride[dimension]
          ? pluralOverride[dimension]
          : `${name}s`
        : name;
    },
    [dimensionLabels]
  );
};
